export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center pt-16">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 min-h-[600px] md:min-h-[700px]">
          <div className="flex flex-col justify-center py-12 md:py-16 lg:py-24 order-2 lg:order-1">
            <div className="max-w-xl">
              <span className="inline-block px-3 py-1 text-xs font-label tracking-wider uppercase text-accent-700 bg-accent-100 rounded-full mb-6">
                Updated Daily
              </span>
              <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-4">
                Discover The Best{" "}
                <span className="italic text-accent-600">Kakobuy Spreadsheet</span>{" "}
                Finds
              </h1>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-lg">
                Explore curated spreadsheets featuring trending products, fashion finds, sneakers, accessories, and buyer guides. Find better products faster with organized shopping lists.
              </p>

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-10">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="group inline-flex items-center gap-3 px-7 py-3.5 bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  <span className="font-label text-sm font-semibold tracking-wide">
                    SHOP ON KAKOBUY SHEET
                  </span>
                  <span className="w-6 h-6 rounded-full bg-accent-500 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                    <i className="ri-arrow-right-up-line text-background-50 text-xs"></i>
                  </span>
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-7 py-3.5 border border-foreground-300/60 text-foreground-800 rounded-full hover:border-foreground-500 hover:text-foreground-950 transition-all duration-200 cursor-pointer whitespace-nowrap font-label text-sm font-semibold"
                >
                  View Latest Finds
                </a>
              </div>

              <div className="flex flex-wrap items-center gap-4 md:gap-6">
                <div className="flex items-center gap-2">
                  <span className="w-5 h-5 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-check-line text-accent-600 text-xs"></i>
                  </span>
                  <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">
                    Updated Product Lists
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-5 h-5 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-check-line text-accent-600 text-xs"></i>
                  </span>
                  <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">
                    Detailed Comparison Guides
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-5 h-5 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-check-line text-accent-600 text-xs"></i>
                  </span>
                  <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">
                    Beginner Friendly
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="w-5 h-5 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-check-line text-accent-600 text-xs"></i>
                  </span>
                  <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">
                    Safety Research
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="relative flex items-center justify-center py-8 lg:py-16 order-1 lg:order-2 bg-secondary-100/60 rounded-2xl overflow-hidden min-h-[360px] md:min-h-[500px]">
            <div className="absolute inset-0 opacity-30">
              <div className="absolute top-6 left-6 w-32 h-32 rounded-lg overflow-hidden rotate-[-6deg]">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20pair%20of%20cream%20suede%20desert%20boots%20resting%20on%20a%20warm%20textured%20linen%20surface%2C%20soft%20diffused%20natural%20window%20light%20from%20the%20left%2C%20very%20shallow%20depth%20of%20field%20creating%20dreamy%20blur%20on%20background%2C%20editorial%20fashion%20photography%20with%20clean%20composition%2C%20warm%20sand%20beige%20and%20soft%20taupe%20color%20palette%2C%20premium%20artisan%20aesthetic%2C%20organic%20textile%20textures%20visible%2C%20elevated%20minimalist%20product%20shot%20with%20sophisticated%20mood&width=300&height=300&seq=hero-gallery-v2-01&orientation=squarish"
                  alt="Premium suede desert boots product photography"
                  title="Premium desert boots - Kakobuy Spreadsheet find"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="absolute top-16 right-8 w-36 h-44 rounded-lg overflow-hidden rotate-[3deg]">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20editorial%20flat%20lay%20of%20a%20structured%20camel%20wool%20blazer%20draped%20over%20a%20warm%20cream%20linen%20backdrop%2C%20soft%20golden%20hour%20light%20casting%20long%20gentle%20shadows%2C%20luxury%20fashion%20brand%20lookbook%20aesthetic%2C%20rich%20warm%20camel%20tan%20and%20cream%20neutral%20tones%2C%20beautiful%20fabric%20texture%20visible%2C%20refined%20minimalist%20composition%20with%20artistic%20negative%20space%2C%20sophisticated%20premium%20clothing%20photography&width=300&height=400&seq=hero-gallery-v2-02&orientation=portrait"
                  alt="Structured camel wool blazer flat lay"
                  title="Premium wool blazer - Kakobuy Spreadsheet find"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="absolute bottom-8 left-10 w-36 h-40 rounded-lg overflow-hidden rotate-[-2deg]">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20flat%20lay%20of%20a%20soft%20cashmere%20knit%20sweater%20in%20muted%20sage%20green%20folded%20on%20a%20warm%20cream%20textured%20paper%20surface%2C%20soft%20overhead%20natural%20lighting%2C%20editorial%20fashion%20photography%2C%20clean%20simple%20composition%20with%20organic%20folds%20and%20gentle%20shadows%2C%20earthy%20neutral%20tones%20with%20subtle%20green%20accent%2C%20modern%20refined%20minimalist%20aesthetic%2C%20luxury%20textile%20photography&width=300&height=350&seq=hero-gallery-v2-03&orientation=portrait"
                  alt="Sage green cashmere knit sweater product photography"
                  title="Cashmere knit sweater - Kakobuy Spreadsheet find"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="absolute top-24 left-[45%] w-28 h-36 rounded-lg overflow-hidden rotate-[5deg]">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20minimalist%20rose%20gold%20analog%20wristwatch%20resting%20on%20a%20smooth%20warm%20cream%20marble%20slab%2C%20natural%20window%20light%20creating%20subtle%20reflections%20on%20the%20polished%20metal%2C%20editorial%20jewelry%20photography%20aesthetic%2C%20soft%20elegant%20luxury%20feel%2C%20warm%20beige%20and%20soft%20metallic%20pink%20tones%2C%20refined%20minimalist%20composition%20with%20beautiful%20light%20play%2C%20high-end%20accessory%20shot%20with%20artistic%20negative%20space&width=280&height=360&seq=hero-gallery-v2-04&orientation=portrait"
                  alt="Rose gold minimalist wristwatch product photography"
                  title="Rose gold watch - Kakobuy Spreadsheet find"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="absolute bottom-14 right-10 w-28 h-32 rounded-lg overflow-hidden rotate-[-4deg]">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20product%20shot%20of%20a%20pair%20of%20tortoiseshell%20round%20sunglasses%20lying%20on%20a%20warm%20cream%20linen%20surface%2C%20soft%20natural%20overhead%20lighting%2C%20modern%20editorial%20accessory%20photography%2C%20warm%20beige%20and%20rich%20amber%20brown%20tones%2C%20subtle%20shadow%20play%2C%20refined%20minimalist%20composition%2C%20premium%20eyewear%20luxury%20aesthetic%2C%20clean%20sophisticated%20mood&width=280&height=320&seq=hero-gallery-v2-05&orientation=portrait"
                  alt="Tortoiseshell round sunglasses product shot"
                  title="Tortoiseshell sunglasses - Kakobuy Spreadsheet find"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="absolute top-[55%] right-[25%] w-24 h-24 rounded-lg overflow-hidden rotate-[6deg]">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20textured%20leather%20crossbody%20bag%20in%20warm%20cognac%20brown%20on%20a%20clean%20cream%20surface%2C%20soft%20diffused%20natural%20daylight%2C%20luxury%20accessory%20editorial%20style%2C%20rich%20warm%20earth%20tones%20with%20beautiful%20leather%20grain%20visible%2C%20simple%20elegant%20composition%2C%20refined%20premium%20aesthetic%2C%20artisan%20craftsmanship%20feel%2C%20gentle%20shadows%20creating%20depth&width=250&height=250&seq=hero-gallery-v2-06&orientation=squarish"
                  alt="Cognac leather crossbody bag product photo"
                  title="Cognac leather bag - Kakobuy Spreadsheet find"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="relative z-10 text-center">
              <div className="w-20 h-20 mx-auto rounded-full bg-background-50 flex items-center justify-center mb-4">
                <i className="ri-search-line text-2xl text-accent-600"></i>
              </div>
              <p className="font-heading text-xl md:text-2xl font-semibold text-foreground-800">
                Curated Daily
              </p>
              <p className="text-sm text-foreground-600 mt-1">14 Categories · 100+ Products</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}